import { fmtN, fmtP, heatCell } from "@/components/overview/Momentum";
import { fmtL } from "./SvcBits";

const LINES = [["total_gs", "Total GS", fmtL], ["body_shop", "Body shop", fmtL], ["gs_ros", "GS ROs", (v) => fmtN(v)]];

export function SvcWeekStrip({ weeks }) {
  return (
    <div className="border bg-card rounded-md overflow-auto" data-testid="sov-week-strip">
      <div className="px-4 py-3 border-b"><h3 className="font-heading text-sm font-semibold">F · Week-wise target vs achieved <span className="text-muted-foreground font-normal text-xs">· month target split by each week's working days · current week highlighted with what is still needed</span></h3></div>
      <div className="grid grid-cols-2 lg:grid-cols-4 divide-x min-w-[560px]">
        {weeks.map((w) => (
          <div key={w.week} className={`p-3 ${w.current ? "bg-amber-50/70 ring-1 ring-inset ring-amber-300" : w.future ? "text-muted-foreground" : ""}`} data-testid={`sov-week-${w.week}`}>
            <div className="flex items-center justify-between mb-1.5">
              <span className="font-heading font-bold text-sm">{w.week} <span className="text-[10px] font-normal text-muted-foreground">{w.start}–{w.end} · {w.wd} wd</span></span>
              {w.current && <span className="rounded bg-amber-200 text-amber-900 px-1.5 py-0.5 text-[9px] font-bold uppercase" data-testid="sov-week-current">now · {w.remaining_wd} wd left</span>}
              {w.done && <span className="text-[9px] uppercase text-muted-foreground">done</span>}
            </div>
            <table className="w-full text-[11px]">
              <tbody>
                {LINES.map(([k, l, f]) => {
                  const c = w.cells[k];
                  return (
                    <tr key={k}>
                      <td className="py-0.5 text-muted-foreground w-16">{l}</td>
                      <td className="py-0.5 text-right num"><b>{c.ach == null ? "—" : f(c.ach)}</b> <span className="text-muted-foreground">/ {c.plan == null ? "—" : f(c.plan)}</span></td>
                      <td className={`py-0.5 text-right num font-semibold w-14 ${w.future ? "" : heatCell(c.pct)}`}>{w.future ? "—" : fmtP(c.pct)}</td>
                      {w.current && <td className="py-0.5 text-right num text-amber-900 w-16 whitespace-nowrap" data-testid={`sov-week-need-${k}`}>{c.remaining ? `need ${f(c.remaining)}` : c.plan == null ? "" : "✓"}</td>}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
  );
}
